'use client';

import React, { useState } from 'react';
import ReactECharts from 'echarts-for-react';

import useTheme from 'hooks/common/useTheme';
import filterEmptyParams from 'utils/common/filterEmptyParams';

import { IChartsProps } from './Chart.types';

const Chart = ({ width, height, style, onChartReady, ...props }: IChartsProps) => {
  const { theme } = useTheme();

  const [currentWidth, setCurrentWidth] = useState(null);

  const handleChartReady = instance => {
    setCurrentWidth(width);

    if (onChartReady) {
      onChartReady(instance);
    }
  };

  return (
    <ReactECharts
      notMerge={true}
      lazyUpdate={true}
      theme={theme}
      style={{ ...filterEmptyParams({ width: currentWidth, height }), ...style }}
      onChartReady={handleChartReady}
      {...props}
    />
  );
};

export default Chart;
